/**
 * Config
 * *******************
 */

var API_BASE_URL = "https://laboxus.digitalmanagement.fr"; 
//var API_BASE_URL = "http://lbh-test.likeweb.fr"; 
var REFERRAL_DISCOUNT_CODE = "CODE_PARRAINAGE";